'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$DeclineRequest(reason) {
  this.Z2 = null;
  this.Z2 = reason;
}
export { $c_Lpresto_types$proto$DeclineRequest as $c_Lpresto_types$proto$DeclineRequest };
$p = $c_Lpresto_types$proto$DeclineRequest.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$DeclineRequest;
/** @constructor */
function $h_Lpresto_types$proto$DeclineRequest() {
}
export { $h_Lpresto_types$proto$DeclineRequest as $h_Lpresto_types$proto$DeclineRequest };
$h_Lpresto_types$proto$DeclineRequest.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_types$proto$DeclineRequest) && (this.Z2 === x$0.Z2)));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "DeclineRequest";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Z2;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$proto$DeclineRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kS)));
}
export { $isArrayOf_Lpresto_types$proto$DeclineRequest as $isArrayOf_Lpresto_types$proto$DeclineRequest };
var $d_Lpresto_types$proto$DeclineRequest = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$DeclineRequest, "presto.types$proto$DeclineRequest", ({
  kS: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$DeclineRequest as $d_Lpresto_types$proto$DeclineRequest };
//# sourceMappingURL=presto.types$proto$-Decline-Request.js.map
